import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export function useUpdateCTA(wireId, newCta) {
  const common = (wId, cta) => ({
    url: `/api/v1/wire/${wId}/cta`,
    data: cta,
  });

  const [state, q] = useAxios({
    method: 'POST',
    ...common(wireId, newCta),
  }, { manual: true });

  const executeQuery = (wId, cta) => q(common(wId, cta));

  return [state, executeQuery];
}

export function useDeleteCTA(wireId) {
  const common = (wId, cta) => ({
    url: `/api/v1/wire/${wId}/cta`,
    data: cta,
  });

  const [state, q] = useAxios({
    method: 'DELETE',
    ...common(wireId),
  }, { manual: true });

  const executeQuery = wId => q(common(wId));

  return [state, executeQuery];
}

export function useGetPresetCTA(wireId) {
  const common = wId => ({
    cache: { ignoreCache: true },
    url: `/api/v1/wire/${wId}/cta/preset`,
    method: 'GET',
  });

  const [state, q] = useAxios(common(wireId), { manual: true });

  const executeQuery = wId => q(common(wId));

  return [state, executeQuery];
}
